var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgTrash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M750,149.959H625V125a50,50,0,0,0-50-50H425a50,50,0,0,0-50,50v24.959H250a75,75,0,0,0-75,75V275H825V224.959A75,75,0,0,0,750,149.959Zm-175,0H425V125H575v24.959ZM225,925H775V299.959H225V925ZM500,400c110.457,0,200,89.543,200,200S610.457,800,500,800,300,710.457,300,600,389.543,400,500,400ZM606.066,653.033L553.033,600l53.033-53.033a37.5,37.5,0,1,0-53.033-53.033L500,546.967l-53.033-53.033a37.5,37.5,0,0,0-53.033,53.033L446.967,600l-53.033,53.033a37.5,37.5,0,1,0,53.033,53.033L500,653.033l53.033,53.033A37.5,37.5,0,1,0,606.066,653.033Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Trash.8ff553d5.svg";
export { ForwardRef as ReactComponent };